import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

/**
 * Returns the doc position immediately after the block identified by `anchorLocalId` —
 * i.e. where an after-block remix result will be inserted. Returns `undefined` when no
 * node with that localId exists in the document.
 */
export function getRemixWidgetPosition(doc: PMNode, anchorLocalId: string): number | undefined {
	let position: number | undefined;

	doc.descendants((node, pos) => {
		if (position !== undefined) {
			return false;
		}
		if (node.attrs?.localId === anchorLocalId) {
			position = pos + node.nodeSize;
			return false;
		}
		return true;
	});

	return position;
}
